





















































































































































/* Les données affichées dans la page proviennent du clic de la fleche dans DefinitionDesBarres.vue, ce clic charge definitionDesBarres/selectedConcour */
import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { Ability } from '@/types/Ability'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ListeDesNotes from '@/views/DefinitionDesBarres/ListeDesNotes.vue'
import StatistiquesEpreuves from '@/views/DefinitionDesBarres/StatistiquesEpreuves.vue'
import Back from '@/components/Tools/Back.vue'
import PopupDefinirLesBarres from '@/components/DefinitionDesBarres/PopupDefinirLesBarres.vue'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import StatistiquesConcours from '@/views/DefinitionDesBarres/StatistiquesConcours.vue'
import AnalyseHypothese from '@/views/DefinitionDesBarres/AnalysesHypotheses.vue'
import PopupExportationListeDesNotes from '@/components/DefinitionDesBarres/PopupExportationListeDesNotes.vue'
import { vowelOrNot } from '@/utils/helpers'
import { BarRuleType } from '@/types/Barre'

@Component({
    methods: { vowelOrNot },
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapGetters('definitionDesBarres', ['tableauDesConcours', 'meta', 'links', 'loading', 'error', 'currentPage', 'lastPage', 'totalPage', 'totalRows', 'selectedConcour'])
    },
    components: {
        'liste-des-notes': ListeDesNotes,
        'font-awesome-icon': FontAwesomeIcon,
        'statistiques-epreuves': StatistiquesEpreuves,
        'statistiques-concours': StatistiquesConcours,
        'analyse-hypothese': AnalyseHypothese,
        Back,
        PopupDefinirLesBarres,
        ErrorDisplay,
        'popup-exportation-liste-des-notes': PopupExportationListeDesNotes
    }
})
export default class DefinitionDesBarresOnglets extends Vue {
    // ************* DATAS
    concour: any = []

    /* Recup de l'id concour afin de le faire passer dans les onglets */
    concourID                       = this.$route.params.id
    /* PopupDefinir les barres */
    showPopupDefinirBarres          = false
    selectedTab                     = 'listeDesNotes'
    togglePopupValidationBarres     = false
    togglePopupInvalidationBarres   = false
    errorKeeper                     = null
    Ability                         = Ability
    showModalExportation            = false
    session                         = this.$store.getters['session/sessionSelect']
    isBarreAdmissionValidated       = false
    bar_rules: any                  = []

    // ************* LISTENERS
    /**
     * watchSelectConcour
     * @description Recharge les données si le concours sélectionné change
     * @return {void}
     */
    @Watch('selectedConcour')
    watchSelecConcour(): void {
        this.concour = this.$store.getters['definitionDesBarres/selectedConcour']
    }

    /**
     * refreshInterface
     * @description Recharge l'interface si l'id de la session change
     * @return {void}
     */
    @Watch('user_session_id')
    refreshInterface(): void {
        this.$router.push({ path: '/definition_des_barres' })
    }

    /**
     * loadBarres
     * @description Charge les barres
     * @return {void}
     */
    @Watch('concour', { deep: true })
    loadBarres() {
        this.bar_rules = []
        if (this.concour?.deliberation?.bar_rules && this.concour?.deliberation?.barres) {
            this.bar_rules = this.concour.deliberation.bar_rules
                .filter((bar_rule: any) => bar_rule.type !== BarRuleType.BAR_RULE_TYPE_ABSENCE)
                .map((bar_rule: any) => {
                    let value: any
                    this.concour.deliberation.barres.some((barre: any) => {
                        return barre.thresholds.some((threshold: any) => {
                            if (threshold.bar_rule_id === bar_rule.id) {
                                value = threshold.value
                                return true
                            }
                        })
                    })

                    return {
                        name: bar_rule.name.charAt(0).toUpperCase() + bar_rule.name.slice(1),
                        id: bar_rule.id,
                        type: bar_rule.type,
                        value: value || null
                    }
                })
        }
    }

    // ************* METHODS
    /**
     * popupDefinitionDesBarres
     * @description Ouvre le popup de définition des barres
     * @return {void}
     */
    popupDefinitionDesBarres(): void {
        this.showPopupDefinirBarres = true
    }

    /**
     * closePopupDefinirLesBarres
     * @description Ferme le popup de définition des barres
     * @return {void}
     */
    closePopupDefinirLesBarres(): void {
        this.showPopupDefinirBarres = false
    }

    /**
     * setSelectedTab
     * @description Définit l'onglet sélectionné
     * @param {string} string - Nom de l'onglet
     * @return {void}
     */
    setSelectedTab(string: string): void {
        this.$store.commit('definitionDesBarres/SET_SELECTED_TAB', string)
    }

    /**
     * togglePopupBarreValidation
     * @description Ouvre ou ferme le popup de validation des barres
     * @return {void}
     */
    togglePopupBarreValidation(): void {
        this.errorKeeper = null
        this.$store.commit('definitionDesBarres/SET_ERROR', null)
        this.togglePopupValidationBarres = !this.togglePopupValidationBarres
    }

    /**
     * togglePopupBarreInvalidation
     * @description Ouvre ou ferme le popup d'invalidation des barres
     * @return {void}
     */
    togglePopupBarreInvalidation(): void {
        this.errorKeeper = null
        this.$store.commit('definitionDesBarres/SET_ERROR', null)

        if (!this.togglePopupInvalidationBarres) {
            this.isBarreAdmissionValidated = this.checkIsBarreAdmissionValidated()
        }

        this.togglePopupInvalidationBarres = !this.togglePopupInvalidationBarres
    }

    /**
     * checkBarresDefinition
     * @description Vérifie si les barres sont définies
     * @return {object | boolean}
     */
    checkBarresDefinition(): object | boolean {
        let barres: any = []
        if (this.concour?.deliberation?.bar_rules && this.concour?.deliberation?.barres) {
            barres = this.concour.deliberation.bar_rules
                .filter((bar_rule: any) => bar_rule.type !== BarRuleType.BAR_RULE_TYPE_ABSENCE)
                .map((bar_rule: any) => {
                    let value: any
                    this.concour.deliberation.barres.some((barre: any) => {
                        return barre.thresholds.some((threshold: any) => {
                            if (threshold.bar_rule_id === bar_rule.id) {
                                value = threshold.value
                                return true
                            }
                        })
                    })

                    return {
                        name: bar_rule.name.charAt(0).toUpperCase() + bar_rule.name.slice(1),
                        value: value || null
                    }
                })

            if (barres.every((b: any) => b.value !== null)) {
                return barres
            }
        }
        return false
    }

    /**
     * checkIsBarreAdmissionValidated
     * @description Vérifie si la barre d'admission a été validée
     * @return {boolean}
     */
    checkIsBarreAdmissionValidated(): boolean {
        // récupération du concours_phase équivalent pour la phase d'admission
        const concourMatch = this.$store.state.definitionDesBarres.tableauDesConcours
            .filter((c: any) => c.concour_id === this.$store.getters['definitionDesBarres/selectedConcour'].concour_id && c.phase_id === 2)
        if (concourMatch.length > 0) {
            return concourMatch[0].deliberation.barreValide === 1
        }
        return false
    }

    /**
     * validateInvalidateBarre
     * @description Valide ou invalide les barres
     * @param {number} state - Etat de validation
     * @return {void}
     */
    validateInvalidateBarre(state: number): void {
        /* TOAST enregistrement en cours */
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
        /* fin toast */

        const params = {
            concourphase: this.concourID,
            _method: 'PUT',
            validate: state,
            data: {
                bar_rules: this.concour.deliberation.bar_rules,
                barres: JSON.parse(JSON.stringify(this.concour.deliberation.barres))
            }
        }
        this.$store.dispatch('definitionDesBarres/putDefinitionDesBarres', params)
            .then(() => {
                this.$store.dispatch('definitionDesBarres/getTableauDesConcours')
                    .then((resp) => {
                        const id = parseInt(this.$route.params.id)
                        this.concour = resp.data.data.filter((concour: { id: any }) => concour.id === id)[0]
                        this.$store.commit('definitionDesBarres/SET_SELECTED_CONCOUR', this.concour)

                        const idSucces = 't_succes_' + Math.random()
                        const succesToaster = {
                            id: idSucces,
                            toaster: 'b-toaster-top-right',
                            variant: 'success',
                            noCloseButton: true,
                            fade: true,
                            autoHideDelay: 5000
                        }

                        const message = `${state === 1 ? 'Validation' : 'Invalidation'} des barres terminée.`
                        this.$bvToast.toast(message, succesToaster)
                        this.togglePopupBarreInvalidation()
                    })
                    .catch(() => {
                        this.errorKeeper = this.$store.getters['definitionDesBarres/error']
                    })
            })
            .catch(() => {
                this.errorKeeper = this.$store.getters['definitionDesBarres/error']
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    /**
     * exporterListeDesNotes
     * @description Ouvre le popup d'exportation
     * @return {void}
     */
    exporterListeDesNotes(): void {
        this.showModalExportation = true
    }

    /**
     * reinitShowModalExportation
     * @description Ferme le popup d'exportation
     * @return {void}
     */
    reinitShowModalExportation() {
        this.showModalExportation = false
    }

    /**
     * load
     * @description Charge les données
     * @return {void}
     */
    load(): void {
        /* toute la logique dessous sert uniquement en cas de refresh de la page */
        const id = parseInt(this.$route.params.id)
        this.concour = this.$store.getters['definitionDesBarres/selectedConcour']
        if (this.concour) {
            this.$store.dispatch('definitionDesBarres/getTableauDesConcours')
                .then((resp) => {
                    const cTemp = resp.data.data.filter((concour: { id: any }) => concour.id === id)[0]
                    if(cTemp) {
                        this.concour = resp.data.data.filter((concour: { id: any }) => concour.id === id)[0]
                    }
                    this.$store.commit('definitionDesBarres/SET_SELECTED_CONCOUR', this.concour)
                })
        }
    }

    /**
     * mounted
     * @description Montage du composant
     * @return {void}
     */
    mounted(): void {
        this.load()
    }
}

